/* eslint no-param-reassign:
	["error", { "props": true, "ignorePropertyModificationsFor": ["element", "attributes"] }]
*/

function setElementStyles(element, styles) {
	Object.entries(styles).forEach((styleArray) => {
		element.style[styleArray[0]] = styleArray[1];
	});
}

function setElementAttrs(element, attributes) {
	Object.entries(attributes).forEach((attributesArray) => {
		if (attributesArray[0] === "class") {
			element.classList.add(attributes.class);
		} else {
			element[attributesArray[0]] = attributesArray[1];
		}
	});
}

export { setElementAttrs };
export { setElementStyles };
export default setElementAttrs;



// WEBPACK FOOTER //
// ./src/mixins/element-attrs.js